import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";
function convert24hrTo12hr(hour) {
    hour = parseInt(hour); // Ensure the hour is an integer
    if (hour === 0) {
        return "12 AM";
    } else if (1 <= hour && hour < 12) {
        return `${hour} AM`;
    } else if (hour === 12) {
        return "12 PM";
    } else if (13 <= hour && hour <= 23) {
        return `${hour - 12} PM`;
    } else {
        throw new Error("Invalid hour value");
    }
}
function generateColor(){
    var colors = ['red', 'green', 'blue', 'orange', 'yellow'];
    var new_c = [];
    var aa = colors[Math.floor(Math.random() * colors.length)];
    new_c.push(aa);
    return new_c;
}
// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class BarChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chart_data:[]
        };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);
        var transactionData = this.props.data
        transactionData.forEach(transaction => {
            transaction["Transaction Time"] = convert24hrTo12hr(transaction["Transaction Time"]);
        });
        this.setState({
            chart_data:transactionData
        })

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
        var valueAxes = [];
        var graphs = [];
        var l = 1;
        var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;


        this.props.y_axis.map(function (pl, index) {
            var bar_color = "#15709f";
             var pos = "right";
            if(pl==='Success') {
                bar_color = "#19fd27";
                pos = "left";
            }
            graphs.push({
                "balloonText": "[[category]]<br>"+pl+":[[value]]",
                "title": pl,
                "type": "column",
                "fillAlphas": 0.8,
                "id": "AmGraph-"+l,
                "lineAlpha": 0.2,
                "fixedColumnWidth": 15,
                "valueField": pl,
                "valueAxis": "v"+l,
                "fillColors":bar_color,
            });

            l++;
        })
        valueAxes.push({
                "id":"v1",
                "axisThickness": 2,
                "position": "left",
                "axisColor": "#E3E3E3",
                "title": "Count",
                "axisAlpha": 1,
                // "titleBold": false,
                "titleColor": "#333333",
                "titleFontSize": 11,
                "precision":0
            })
        const config = {
            "type": "serial",
            "columnSpacing": 0,
            "theme": "light",
            "legend": {
                "useGraphSettings": true,
                // "verticalGap":4,
                "valueFunction": function(graphDataItem, valueText) {
                    return "";
                 },
                "align": "center",
                "autoMargins": false,
                "equalWidths": false,
                "valueAlign": "left",
                "valueWidth": 10,
                "fontSize":8,
                "marginLeft":0,
                "marginRight":0,
                "marginTop":0,
                "marginBottom":0,
                "verticalGap":5,
                "position":"top"
            },
            "marginTop": 5,
            "marginRight": 10,
            "marginLeft": 20,
            "autoMarginOffset": 20,
            "mouseWheelZoomEnabled": true,
            "dataProvider": this.state.chart_data,
            "synchronizeGrid":true,
            "valueAxes": valueAxes,
            "graphs": graphs,
            "chartScrollbar": {
                "enabled":false,
                "graph": "g1",
                "autoHide": true,
                "oppositeAxis": false,
                "offset":30,
                "scrollbarHeight": 80,
                "backgroundAlpha": 0,
                "selectedBackgroundAlpha": 0.1,
                "selectedBackgroundColor": "#888888",
                "graphFillAlpha": 0,
                "graphLineAlpha": 0.5,
                "selectedGraphFillAlpha": 0,
                "selectedGraphLineAlpha": 1,
                "autoGridCount": true,
                "color":"#AAAAAA"
            },
            "chartCursor": {
                "pan": true,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha":1,
                "cursorColor":"#258cbb",
                "limitToGraph":"g1",
                "valueLineAlpha":0.2,
                "valueZoomable": true,
                "zoomable": true
            },
            "valueScrollbar":{
                "enabled" :false,
                "oppositeAxis": false,
                "offset":50,
                "scrollbarHeight":10
            },
            "categoryField": this.props.x_axis,
            "categoryAxis": {
//                 "parseDates": true,
//                 "minPeriod":"WW",
                "dashLength": 1,
                "minorGridEnabled": false,
                //"labelRotation": 25,
                "fontSize":8,
            },
//             "export": {
//                 "enabled": true,
//                 "fileName": fileName.replace(/ /g,"_"),
//                 "menu": [ {
//                 "class": "export-main",
//                 "menu": ["XLSX", "CSV" ],
//               } ]
//             },
            listeners:[{
                    "event": "clickGraphItem",
                    "method": (e)=>{this.handleClick(e.item)}
                }]
    };

        return (
            <div className ="chart_div" >
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight }} options={config} />
            </div>
        );
    }
      }

export default BarChart;